window.addEventListener('load', () => {
  modalQueryMap();
});

function modalQueryMap() {
  if (document.querySelector('.js-modalClose')) {
    const bodyEle = document.querySelector('body');
    const modalMap = document.querySelector('.js-modalMap');
    const modalMapBody = document.querySelector('.js-modalMapBody');
    const modalClose = document.querySelector('.js-modalClose');
    const modalGmapTrigger = document.querySelectorAll('.js-modalGmapTrigger');
    const modalGmapTriggerList = Array.prototype.slice.call(modalGmapTrigger, 0);

    /** google map iframe */
    // 静岡営業所
    const mapShizuoka = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3268.8911484341734!2d138.38547811192646!3d34.9843911727069!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a4b18e9faa9cf%3A0x4a06a70ee7cbec67!2zTlRU6KW_5pel5pysIOWfjuadseODk-ODqw!5e0!3m2!1sja!2sjp!4v1688351422736!5m2!1sja!2sjp', 'https://goo.gl/maps/uH4qAGpH8Ss9yGrs6'];
    const mapGifu = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3251.7475246339322!2d136.77920471194247!3d35.411508172561675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6003a9042775affb%3A0x6b6aba0187dd2838!2zTlRU6KW_5pel5pysIOmVt-ajrumbu-ipseS6pOaPm-aJgA!5e0!3m2!1sja!2sjp!4v1688352010502!5m2!1sja!2sjp', 'https://goo.gl/maps/V37Gwmqys8NkwZer6'];
    const mapMie = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.569542262234!2d136.89740726193332!3d35.167354722643836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6003772b8d3611cb%3A0xeab3d016a30ac8d1!2zTlRU6KW_5pel5pysIOW6g-Wwj-i3r-mbu-ipseS6pOaPm-aJgA!5e0!3m2!1sja!2sjp!4v1688351179356!5m2!1sja!2sjp'];
    const mapKagawa = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d823.6458548558417!2d134.0508819285428!3d34.33562699830869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3553eb98e34db797%3A0xde7e8442783ae55a!2z44CSNzYwLTAwNTUg6aaZ5bed55yM6auY5p2-5biC6Kaz5YWJ6YCa77yR5LiB55uu77yY4oiS77yS!5e0!3m2!1sja!2sjp!4v1688434740491!5m2!1sja!2sjp', 'https://goo.gl/maps/W7wv2Nj9p3YKJ2gW7'];
    const mapFukuoka = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.3991807165175!2d130.4052306118764!3d33.59494577322135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191eb24e30edb%3A0xe3d8f67f8f7a369c!2z44CSODEyLTAwMjYg56aP5bKh55yM56aP5bKh5biC5Y2a5aSa5Yy65LiK5bed56uv55S677yR77yT4oiS77yYIO-8ru-8tO-8tOilv-aXpeacrCDljZrlpJrvvKTvvK_vvKnvvK3vvKHvvKPvvKjvvKnjg5Pjg6s!5e0!3m2!1sja!2sjp!4v1688433539297!5m2!1sja!2sjp', 'https://goo.gl/maps/1VPfWxoQEmatLmmr6'];
    const mapKitaKyusyu = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.3991807165175!2d130.4052306118764!3d33.59494577322135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191eb24e30edb%3A0xe3d8f67f8f7a369c!2z44CSODEyLTAwMjYg56aP5bKh55yM56aP5bKh5biC5Y2a5aSa5Yy65LiK5bed56uv55S677yR77yT4oiS77yYIO-8ru-8tO-8tOilv-aXpeacrCDljZrlpJrvvKTvvK_vvKnvvK3vvKHvvKPvvKjvvKnjg5Pjg6s!5e0!3m2!1sja!2sjp!4v1688433539297!5m2!1sja!2sjp', 'https://goo.gl/maps/1VPfWxoQEmatLmmr6'];
    const mapKumamoto = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3353.699747522816!2d130.71381461184856!3d32.800219673544106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3540f3f58ef49b79%3A0x91c90de95b5e8377!2zTlRU6KW_5pel5pysIOS5neWTgeWvuumbu-ipseS6pOaPm-aJgA!5e0!3m2!1sja!2sjp!4v1688433882363!5m2!1sja!2sjp', 'https://goo.gl/maps/4qv1G9ALqt44YDzF7'];
    const mapKagoshima = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3398.695645057715!2d130.55490881180705!3d31.587393074075592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353e60abc9b7322d%3A0xd8bd0a1aa729ec04!2z44CSODkyLTA4MzMg6bm_5YWQ5bO255yM6bm_5YWQ5bO25biC5p2-5Y6f55S677yU4oiS77yS77yW!5e0!3m2!1sja!2sjp!4v1688434004538!5m2!1sja!2sjp', 'https://goo.gl/maps/hRzLWgeWtzzRNttA9'];
    const mapOkinawa = ['https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3578.5894200686657!2d127.68796111164175!3d26.2425271769574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34e56bc85d8727ab%3A0x2918ce8dc15b33c3!2z77yI5qCq77yJ77yu77y077y06KW_5pel5pys44Ki44K744OD44OI44O744OX44Op44Oz44OL44Oz44KwIOS5neW3nuaUr-W6l-aylue4hOWWtualreaJgA!5e0!3m2!1sja!2sjp!4v1688434071366!5m2!1sja!2sjp', 'https://goo.gl/maps/rA6AqpCwaLFwaNWM6'];
    /** end google map iframe */

    modalGmapTriggerList.forEach((targetBox) => {
      targetBox.addEventListener('click', () => {
        // マップ情報取得 + 設定
        const mapData = targetBox.getAttribute('data-map');
        let mapIframe = '';
        let mapLink = '';

        switch (mapData) {
          case 'shizuoka':
            mapIframe = mapShizuoka[0];
            mapLink = mapShizuoka[1];
            break;
          case 'gifu':
            mapIframe = mapGifu[0];
            mapLink = mapGifu[1];
            break;
          case 'mie':
            mapIframe = mapMie[0];
            mapLink = mapMie[1];
            break;
          case 'kagawa':
            mapIframe = mapKagawa[0];
            mapLink = mapKagawa[1];
            break;
          case 'fukuoka':
            mapIframe = mapFukuoka[0];
            mapLink = mapFukuoka[1];
            break;
          case 'kitakyusyu':
            mapIframe = mapKitaKyusyu[0];
            mapLink = mapKitaKyusyu[1];
            break;
          case 'kumamoto':
            mapIframe = mapKumamoto[0];
            mapLink = mapKumamoto[1];
            break;
          case 'kagoshima':
            mapIframe = mapKagoshima[0];
            mapLink = mapKagoshima[1];
            break;
          case 'okinawa':
            mapIframe = mapOkinawa[0];
            mapLink = mapOkinawa[1];
            break;
          default:
            break;
        }

        // マップDOM生成
        const mapCont = document.createElement('div');
        mapCont.className = 'c-modalMap_bodyInner';
        mapCont.innerHTML = '<div class="c-modalMap_frame js-modalMapFrame"><iframe src="' + mapIframe + '" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div><p class="c-modalMap_link"><a href="' + mapLink + '" target="_blank" class="c-modalMap_linkItem c-linkText"><span class="c-linkText_inner">Google マップで見る</span></a></p>';
        modalMapBody.appendChild(mapCont);

        // マップ表示
        bodyEle.classList.add('is-fixed');
        modalMap.classList.add('is-view');
      });
    });

    if (document.querySelector('.js-modalClose')) {
      modalClose.addEventListener('click', () => {
        const modalMapFrame = document.querySelector('.c-modalMap_bodyInner');
        modalMapBody.removeChild(modalMapFrame);

        bodyEle.classList.remove('is-fixed');
        modalMap.classList.remove('is-view');
      });
    }
  }
}
